import React from 'react';
import { Link } from 'react-router-dom';


const CaracteristicasMuroLambrinConcavo = () => {
  return (
    <section className="service-features">
      <div className="container">
      <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Versatilidad y Elegancia para Interiores disponible en color: Madera, Terracota y Nogal</h2>
        </div>
        <div className="row g-0">
          <p>Se pueden instalar de forma versátil en paredes y techos en espacios interiores, siendo perfectos incluso para áreas de doble altura.</p>
          <div className="col-lg-4">
            <div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="bg-img cover-background service-img"
                    style={{
                      backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/productos/muro-lambrin-concavo/muro-lambrin-concavo-caracteristicas.jpg)`,
                    }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="py-1-6 py-xl-5 px-1-9 px-xl-5 text-center">
                    <i className="icon-scope display-13 text-secondary mb-4"></i>
                    <h3 className="h5 mb-3">
                    <Link to="/contacto-decototal">Medidas</Link>
                    </h3>
                    <p className="mb-sm-1-9 text-color-light-blue">
                    Largo 2.90 X Ancho 19cm. X 15mm. de Grosor.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div>
              <div className="row">
                <div className="col-12 order-2 order-lg-1">
                  <div className="py-1-6 py-xl-5 px-1-9 px-xl-5 text-center">
                    <i className="icon-scope display-13 text-secondary mb-4"></i>
                    <h3 className="h5 mb-3">
                    <Link to="/contacto-decototal">Modelos</Link>
                    </h3>
                    <p className="mb-sm-1-9 text-color-light-blue">
                    Disponibles en una amplia gama de colores y acabados para adaptarse a cualquier estilo.
                    </p>
                  </div>
                </div>
                <div className="col-12 order-1 order-lg-2">
                  <div
                    className="bg-img cover-background service-img"
                    style={{
                      backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/productos/muro-lambrin-concavo/muro-lambrin-concavo-caracteristicas-02.jpg)`,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="bg-img cover-background service-img"
                    style={{
                      backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/productos/muro-lambrin-concavo/muro-lambrin-concavo-caracteristicas-03.jpg)`,
                    }}
                  ></div>
                </div>
                <div className="col-12">
                  <div className="py-1-6 py-xl-5 px-1-9 px-xl-5 text-center">
                    <i className="icon-scope display-13 text-secondary mb-4"></i>
                    <h3 className="h5 mb-3">
                    <Link to="/contacto-decototal">Material</Link>
                    </h3>
                    <p className="mb-sm-1-9 text-color-light-blue">
                    Fabricados con un compuesto de madera y plástico de alta durabilidad, garantizando resistencia y calidad.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaracteristicasMuroLambrinConcavo;
